import React, { Component } from "react"
import MetaTags from 'react-meta-tags';
import PropTypes from 'prop-types'
import { connect } from "react-redux"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import { withTranslation } from "react-i18next"
import "flatpickr/dist/themes/material_blue.css"
import SettingSidebar from "../../../components/VerticalLayout/SettingSidebar";
import { getUserDetail, updateUserCurrency } from "../../../store/actions"
import {
    Container,
    Row,
    Col,
    Card,
    CardBody,
    FormGroup,
    Label,
    Offcanvas,
    OffcanvasHeader,
    OffcanvasBody,
} from "reactstrap"
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import UpdateButton from "components/buttons/updateBtn";
import CurrencyDropdown from "components/dropdowns/Other/CurrencyDropdowns";
import gmailIcon from "../../../assets/img/Gmail_Icon.png"
import emailIcon from "../../../assets/img/send-mass-email.png"
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import { API_URL } from "helpers/app_url";
import axios from "axios";
import { map } from "lodash";
import SafeField from "helpers/SafeField";
class EmailConnect extends Component {
    constructor(props) {
        super(props)
        this.state = {
              isGmailActive : false,
                isCalActive : false,
          
            isLoading:false
        }
        this.handleGmailClick = this.handleGmailClick.bind(this);
        this.deactivateGmail = this.deactivateGmail.bind(this);
        this.addcustomemail = this.addcustomemail.bind(this);
    }
    componentDidMount() {
        const { onGetUserDetail } = this.props;
        
        onGetUserDetail(localStorage.getItem('userId'));
        this.allEmailLists();
      }
    addcustomemail(){
        this.setState({ isNewEmail: !this.state.isNewEmail });
        
    }
    componentDidUpdate(prevProps) {
        if (
            this.props.userdetail?.agentId &&
            prevProps.userdetail?.agentId !== this.props.userdetail?.agentId
        ) {
            this.allEmailLists();
        }
}
allEmailLists = async () => {
  try {
    const authData = localStorage.getItem("authUser");
    if (!authData) return;

    const obj = JSON.parse(authData);
    const token = obj?.resultData?.bearerToken;
    const agentId = this.props.userdetail?.agentId;

    if (!token || !agentId) return;

    const headers = { Authorization: `Bearer ${token}` };

    const res = await axios.get(`${API_URL}EmailAgentGeneralCredentials/allforagent`, {
      params: { agentId },
      headers
    });

    this.setState({ emailLists: res.data });

  } catch (error) {
    console.error("Error fetching email lists:", error);
  }
}

 handleDelete = (emailM) => {
    toast.loading("Please wait...");
    const obj = JSON.parse(localStorage.getItem("authUser"));
    const token = obj.resultData.bearerToken;
    const str = 'Bearer ' + token;
    var authOptions = {
      method: 'delete',
      url: `${API_URL}/EmailAgentGeneralCredentials/` + emailM.emailAgentGeneralCredentialId,
      headers: { Authorization: str }
    };

    axios(authOptions)
      .then((response) => {
        if (response.data.success) {
          toast.dismiss();
          toast.success("Email Delete");
          this.allEmailLists();
        }
        else {
          toast.dismiss();
          toast.error(response.data.validationErrors[0]);
          this.allEmailLists();
        }
      })
      .catch((error) => {
        toast.dismiss();
        toast.success("Error" + error);
      })
  };
handleSubmitCustomEmail = (values) => {
     const obj = JSON.parse(localStorage.getItem("authUser"));
     const token = obj?.resultData?.bearerToken;
     const payload = {
            agentEmailId: values.emailUserId,
            emailUserId: values.emailUserId,
            emailPassword: values.emailPassword,
            agentId: values.agentId,
            emailType: 'IMAP',
            emailConnectType: 'IMAP',
            lastQueryDate: values.lastQueryDate,
            emailHostServer: values.emailHostServer,
            emailHostPort: values.emailHostPort,
            emailHostSSLRequired: (values.outgoingEmailHostSSLRequired) ? true : false,
            outgoingEmailHostServer:values.outgoingEmailHostServer,
            outgoingEmailUserId:(values.outgoingEmailUserId) ? values.outgoingEmailUserId : values.emailUserId,
            outgoingEmailPassword: (values.outgoingEmailPassword) ? values.outgoingEmailPassword : values.emailPassword,
            outgoingEmailHostPort: values.outgoingEmailHostPort,
            outgoingEmailHostSSLRequired:(values.outgoingEmailHostSSLRequired) ? true : false,
            createdOn: values.createdOn,
            defaultUseToSendmail: false,
            isActive:true
     }
     toast.loading('Please wait......')
     axios.post(`${API_URL}EmailAgentGeneralCredentials`, payload, {
      headers: { Authorization: `Bearer ${token}` },
    })
    .then(response => {
      
      if(response.data.success){
        toast.dismiss();
        toast.success("Saved Successfully");
        this.allEmailLists();
        this.addcustomemail();
  }else{
        toast.dismiss();
        toast.error(response.data.validationErrors[0]);
        

  }
    })
    .catch(error => {
      console.error("API Error:", error);
     
    });

}
handlePrimaryEmail= (emailM) => {

    toast.loading("Please wait...");
    const obj = JSON.parse(localStorage.getItem("authUser"));
    const token = obj.resultData.bearerToken;
    const str = 'Bearer ' + token;
    var authOptions = {
      method: 'PUT',
      url: `${API_URL}/EmailAgentGeneralCredentials/UpdateEmailAgentGeneralCredentialSendmail`,
      headers: { Authorization: str },
       data: {
            emailAgentGeneralCredentialId: emailM.emailAgentGeneralCredentialId,
            agentId: emailM.agentId,
            defaultUseToSendmail: true
        }
    };

    axios(authOptions)
      .then((response) => {
        if (response.data.success) {
          toast.dismiss();
          toast.success("Primary Email Changed");
          this.allEmailLists();
        }
        else {
          toast.dismiss();
          toast.error(response.data.validationErrors[0]);
          this.allEmailLists();
        }
      })
      .catch((error) => {
        toast.dismiss();
        toast.success("Error" + error);
      })

};
  handleGmailClick() {
        this.setState({ isLoading: true });
        const obj = JSON.parse(localStorage.getItem("authUser"));
        const token = obj?.resultData?.bearerToken;
        const userId = this.props.userdetail?.agentId;
        const url = `${API_URL}Gmail/Auth/${userId}/0`;
        axios.get(url)
            .then(response => {
                window.location.href = response.data;
                this.setState({ isLoading: false });
            })
            .catch(error => {
                const errorMessage = error.response?.data?.message || "Some error.";
                toast.error(errorMessage);
                this.setState({ isLoading: false });
            });
    }
    deactivateGmail() {
       this.setState({ isLoading: true });
        const obj = JSON.parse(localStorage.getItem("authUser"));
        const token = obj?.resultData?.bearerToken;
       const userId = this.props.userdetail?.agentId;
        const url = `${API_URL}Gmail/DeActivateGoogleEmail/${userId}`;
            axios.get(url,{
                headers: { Authorization: `Bearer ${token}` },
            })
            .then(response => {
                //window.location.href = response.data;
                this.setState({ isLoading: false });
            })
            .catch(error => {
                const errorMessage = error.response?.data?.message || "Some error.";
                toast.error(errorMessage);
                this.setState({ isLoading: false });
            });
    }
    render() {
        const { userdetail } = this.props;
        //
        const { emailLists } =  this.state;
        return (
            <React.Fragment>
                 <ToastContainer autoClose={2000} />
                <div className="page-content">
                    <MetaTags>
                        <title>Email Connect | Realty Space</title>
                    </MetaTags>
                    <Container fluid>
                        <Row className="mb20">
                            <Col xl="6">
                                <Breadcrumbs
                                    title={this.props.t("Agent")}
                                    breadcrumbItem={this.props.t("General Settings")}
                                />
                            </Col>
                        </Row>
                        <Row>
                            <Col xl="3">
                                <SettingSidebar />
                            </Col>
                            <Col xl="9">
                               
                                 <div className="row g-4">
                                 <div className="col-md-2"></div>
                                <div className="col-md-2">
                                     <Link onClick={ this.handleGmailClick }>                                                      
                                    <div className="email-option">
                                    <img src={gmailIcon} alt="Gmail" />
                                    <h5>Gmail</h5>
                                    <p>Connect a Gmail account to your inbox</p>
                                    </div>
                                    </Link>
                                </div>
                             
                                <div className="col-md-2">
                                    <Link to="#" onClick={this.addcustomemail}>
                                    <div className="email-option">
                                    <img src={emailIcon} alt="Other mail" />
                                    <h5>Other mail account</h5>
                                    <p>Connect other accounts by setting up email forwarding</p>
                                    </div>
                                    </Link>
                                </div>
                                </div>

                                    <Card className="border-full mt-4">
                                        <CardBody>
                                                 <h5 className="card-title">Current Settings</h5>

                                                  <table className="table table-bordered">
                                                      
                                                        <tbody>
                                                              {map(emailLists, (emailM, classkey) => (
                                                                <tr key={"_list_" + classkey}>
                                                                         <td>{emailM.agentEmailId}</td>
                                                                         <td>Reconnect</td>
                                                                         <td>
                                                                             <a
                                                                                href="#"
                                                                                onClick={(e) => {
                                                                                e.preventDefault();
                                                                                this.handleDelete(emailM);
                                                                                }}
                                                                                className="action-button"
                                                                            >Remove</a></td>
                                                                         <td>
                                                                           {emailM.defaultUseToSendmail ? 
                                                                            'Primary': 

                                                                               <a
                                                                                href="#"
                                                                                onClick={(e) => {
                                                                                e.preventDefault();
                                                                                this.handlePrimaryEmail(emailM);
                                                                                }}
                                                                                className="action-button"
                                                                            >Set as Primary</a> 
                                                                            }
                                                                            </td>
                                                                </tr>
                                                              ))}
                                                        </tbody>
                                                    </table>
                                        </CardBody>
                                    </Card>
                                   
                                   
                            </Col>
                        </Row>
                    </Container>


                    <Offcanvas
                              isOpen={this.state.isNewEmail}
                              direction="end"
                              toggle={this.addcustomemail}
                            >
                              <OffcanvasHeader toggle={this.addcustomemail}>
                               Add New Email
                              </OffcanvasHeader>
                              <OffcanvasBody>
                                  <Formik
                                                  enableReinitialize={true}
                                                  initialValues={{
                                                    agentEmailId: "",
                                                    agentId: userdetail?.agentId,
                                                    emailType: "",
                                                    emailConnectType:"",
                                                    lastQueryDate: new Date(),
                                                    emailHostServer:"",
                                                    emailUserId:"",
                                                    emailPassword:"",
                                                    emailHostPort:"",
                                                    emailHostSSLRequired: "",
                                                    outgoingEmailHostServer:'',
                                                    outgoingEmailUserId:'',
                                                    outgoingEmailPassword:'',
                                                    outgoingEmailHostPort:'',
                                                    outgoingEmailHostSSLRequired:true,
                                                    createdOn:new Date(),
                                                    defaultUseToSendmail: false,
                                                    isActive:true,
                                                    outGoing:false

                                                  }}
                                                  validationSchema={Yup.object().shape({
                                                   // emailConnectType:Yup.string().required('This Field in required'),
                                                    emailHostServer: Yup.string().required('This Field in required'),
                                                    emailUserId: Yup.string().email('Invalid email').required('This Field in required'),
                                                    emailPassword: Yup.string().required("This Field in required"),
                                                    emailHostPort: Yup.string().required("This Field in required"),
                                                    outgoingEmailHostServer :Yup.string().required("This Field in required"),
                                                    outgoingEmailHostPort:Yup.string().required("This Field in required"),

                                                    outgoingEmailUserId: Yup.string().when('outGoing', {
                                                      is: true,
                                                      then: (schema) => schema.required('This Field is required'),
                                                      otherwise: (schema) => schema.notRequired(),
                                                    }),

                                                    outgoingEmailPassword: Yup.string().when('outGoing', {
                                                      is: true,
                                                      then: (schema) => schema.required('This Field is required'),
                                                      otherwise: (schema) => schema.notRequired(),
                                                    }),


                                                    
                                                  })}
                                
                                                  onSubmit={this.handleSubmitCustomEmail}
                                                >
                                                  {({ errors, touched, values, handleChange, setFieldValue }) => (
                                                    <Form
                                                      className="needs-validation"
                                                    >
                                                   
                                                         
                                                          <Row>
                                                             
                                                              <Col sm="12">
                                                              <FormGroup className="mb-3">
                                                                <Label htmlFor="emailUserId">
                                                                 Email Address *
                                                                </Label>
                                                                <SafeField
                                                                  name="emailUserId"
                                                                  onChange={handleChange}
                                
                                                                  type="text"
                                
                                                                  className={
                                                                    "form-control" +
                                                                    (errors.emailUserId && touched.emailUserId
                                                                      ? " is-invalid"
                                                                      : "")
                                                                  }
                                
                                                                  id="emailUserId"
                                                                />
                                                                <ErrorMessage
                                                                  name="emailUserId"
                                                                  component="div"
                                                                  className="invalid-feedback"
                                                                />
                                                              </FormGroup>
                                                            </Col>

                                                              <Col sm="12">
                                                              <FormGroup className="mb-3">
                                                                <Label htmlFor="emailPassword">
                                                                 Password *
                                                                </Label>
                                                                <SafeField
                                                                  name="emailPassword"
                                                                  onChange={handleChange}
                                
                                                                  type="password"
                                
                                                                  className={
                                                                    "form-control" +
                                                                    (errors.emailPassword && touched.emailPassword
                                                                      ? " is-invalid"
                                                                      : "")
                                                                  }
                                
                                                                  id="emailPassword"
                                                                />
                                                                <ErrorMessage
                                                                  name="emailPassword"
                                                                  component="div"
                                                                  className="invalid-feedback"
                                                                />
                                                              </FormGroup>
                                                            </Col>
                                                            <Col sm="12">
                                                                 <FormGroup className="mb-3">
                                                                    <Label htmlFor="outGoing">
                                                                    <SafeField type="checkbox" name="outGoing" id="outGoing" className="me-2" />
                                                                          My outgoing server credentials are different from Incoming
                                                                    </Label>
                                                                  </FormGroup> 
                                                            </Col>
                                                            <Col sm="12">
                                                                  <h5 className="card-title"> Incoming Mail (IMAP) *</h5>
                                                            </Col>
                                                            
                                                            <Col sm="8">
                                                              <FormGroup className="mb-3">
                                                                <Label htmlFor="emailHostServer">
                                                                  Server  *
                                                                </Label>
                                                                <SafeField
                                                                  name="emailHostServer"
                                                                  onChange={handleChange}
                                
                                                                  type="text"
                                
                                                                  className={
                                                                    "form-control" +
                                                                    (errors.emailHostServer && touched.emailHostServer
                                                                      ? " is-invalid"
                                                                      : "")
                                                                  }
                                
                                                                  id="emailHostServer"
                                                                />
                                                                <ErrorMessage
                                                                  name="emailHostServer"
                                                                  component="div"
                                                                  className="invalid-feedback"
                                                                />
                                                              </FormGroup>
                                                            </Col>
                                
                                                          

                                                              <Col sm="4">
                                                              <FormGroup className="mb-3">
                                                                <Label htmlFor="emailHostPort">
                                                                 Port *
                                                                </Label>
                                                                <SafeField
                                                                  name="emailHostPort"
                                                                  onChange={handleChange}
                                
                                                                  type="text"
                                
                                                                  className={
                                                                    "form-control" +
                                                                    (errors.emailHostPort && touched.emailHostPort
                                                                      ? " is-invalid"
                                                                      : "")
                                                                  }
                                
                                                                  id="emailHostPort"
                                                                />
                                                                <ErrorMessage
                                                                  name="emailHostPort"
                                                                  component="div"
                                                                  className="invalid-feedback"
                                                                />
                                                              </FormGroup>
                                                            </Col>


                                                             <Col sm="12">
                                                                  <h5 className="card-title"> Outgoing Mail (SMTP)</h5>
                                                            </Col>
                                                            {values.outGoing && (
                                                            <>
                                                              <Col sm="6">
                                                              <FormGroup className="mb-3">
                                                                <Label htmlFor="outgoingEmailUserId">
                                                                 Email Address *
                                                                </Label>
                                                                <SafeField
                                                                  name="outgoingEmailUserId"
                                                                  onChange={handleChange}
                                
                                                                  type="text"
                                
                                                                  className={
                                                                    "form-control" +
                                                                    (errors.outgoingEmailUserId && touched.outgoingEmailUserId
                                                                      ? " is-invalid"
                                                                      : "")
                                                                  }
                                
                                                                  id="outgoingEmailUserId"
                                                                />
                                                                <ErrorMessage
                                                                  name="outgoingEmailUserId"
                                                                  component="div"
                                                                  className="invalid-feedback"
                                                                />
                                                              </FormGroup>
                                                            </Col>

                                                              <Col sm="6">
                                                              <FormGroup className="mb-3">
                                                                <Label htmlFor="outgoingEmailPassword">
                                                                 Password *
                                                                </Label>
                                                                <SafeField
                                                                  name="outgoingEmailPassword"
                                                                  onChange={handleChange}
                                
                                                                  type="password"
                                
                                                                  className={
                                                                    "form-control" +
                                                                    (errors.outgoingEmailPassword && touched.outgoingEmailPassword
                                                                      ? " is-invalid"
                                                                      : "")
                                                                  }
                                
                                                                  id="outgoingEmailPassword"
                                                                />
                                                                <ErrorMessage
                                                                  name="outgoingEmailPassword"
                                                                  component="div"
                                                                  className="invalid-feedback"
                                                                />
                                                              </FormGroup>
                                                            </Col>
                                                            </>
                                                            )}
                                                            <Col sm="8">
                                                              <FormGroup className="mb-3">
                                                                <Label htmlFor="outgoingEmailHostServer">
                                                                  Server  *
                                                                </Label>
                                                                <SafeField
                                                                  name="outgoingEmailHostServer"
                                                                  onChange={handleChange}
                                
                                                                  type="text"
                                
                                                                  className={
                                                                    "form-control" +
                                                                    (errors.outgoingEmailHostServer && touched.outgoingEmailHostServer
                                                                      ? " is-invalid"
                                                                      : "")
                                                                  }
                                
                                                                  id="outgoingEmailHostServer"
                                                                />
                                                                <ErrorMessage
                                                                  name="outgoingEmailHostServer"
                                                                  component="div"
                                                                  className="invalid-feedback"
                                                                />
                                                              </FormGroup>
                                                            </Col>
                                
                                                          

                                                              <Col sm="4">
                                                              <FormGroup className="mb-3">
                                                                <Label htmlFor="outgoingEmailHostPort">
                                                                 Port *
                                                                </Label>
                                                                <SafeField
                                                                  name="outgoingEmailHostPort"
                                                                  onChange={handleChange}
                                
                                                                  type="text"
                                
                                                                  className={
                                                                    "form-control" +
                                                                    (errors.outgoingEmailHostPort && touched.outgoingEmailHostPort
                                                                      ? " is-invalid"
                                                                      : "")
                                                                  }
                                
                                                                  id="outgoingEmailHostPort"
                                                                />
                                                                <ErrorMessage
                                                                  name="outgoingEmailHostPort"
                                                                  component="div"
                                                                  className="invalid-feedback"
                                                                />
                                                              </FormGroup>
                                                            </Col>
                                                             <Col sm="12">
                                                                 <FormGroup className="mb-3">
                                                                    <Label htmlFor="outgoingEmailHostSSLRequired">
                                                                    <SafeField type="checkbox" name="outgoingEmailHostSSLRequired" id="outgoingEmailHostSSLRequired" className="me-2" />
                                                                          Required SSL
                                                                    </Label>
                                                                  </FormGroup> 
                                                            </Col>
                                                            <Col sm="12">
                                                              <UpdateButton btnClass="mt-27">Add</UpdateButton>
                                
                                                            </Col>
                                
                                
                                                          </Row>
                                
                                
                                
                                
                                                       
                                
                                                     
                                                        
                                                     
                                                    </Form>
                                                  )}
                                                </Formik>
                    
                              </OffcanvasBody>
                              </Offcanvas>
                </div>
            </React.Fragment>
        )
    }
}
EmailConnect.propTypes = {
    t: PropTypes.any,
    history: PropTypes.object,
    match: PropTypes.object,
    onGetUserDetail:PropTypes.func,
    userdetail:PropTypes.object,
    onUpdateUserCurrency:PropTypes.func
}
const mapStateToProps = ({Login}) => (
    {
            userdetail : Login.userdetail
    })
const mapDispatchToProps = dispatch => ({
    onGetUserDetail: (agentId) => dispatch(getUserDetail(agentId)),
    
});
export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(EmailConnect))
